<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M4,8C4.28,8,4.53,7.89,4.71,7.71C4.71,7.71,8,4.41,8,4.41C8,4.41,11.29,7.7,11.29,7.7C11.47,7.89,11.72,8,12,8C12.55,8,13,7.55,13,7C13,6.72,12.89,6.47,12.71,6.29C12.71,6.29,8.71,2.29,8.71,2.29C8.530000000000001,2.11,8.280000000000001,2,8,2C7.72,2,7.47,2.11,7.29,2.29C7.29,2.29,3.29,6.29,3.29,6.29C3.11,6.47,3,6.72,3,7C3,7.55,3.45,8,4,8C4,8,4,8,4,8ZM8.71,7.29C8.530000000000001,7.11,8.280000000000001,7,8,7C7.72,7,7.47,7.11,7.29,7.29C7.29,7.29,3.29,11.29,3.29,11.29C3.11,11.47,3,11.72,3,12C3,12.55,3.45,13,4,13C4.28,13,4.53,12.89,4.71,12.71C4.71,12.71,8,9.41,8,9.41C8,9.41,11.29,12.7,11.29,12.7C11.47,12.89,11.72,13,12,13C12.55,13,13,12.55,13,12C13,11.72,12.89,11.47,12.71,11.29C12.71,11.29,8.71,7.29,8.71,7.29C8.71,7.29,8.71,7.29,8.71,7.29Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DoubleChevronUp',
} as DefineComponent
</script>
